// @flow

import * as React from 'react';

type State = {
  windowHeight: number,
  windowWidth: number,
};

type Props = {
  children: State => React.Node,
};

const RESIZE_EVENT = 'resize';

const getWindowSize = (): State => ({
  windowHeight: (window.innerHeight: number),
  windowWidth: (window.innerWidth: number),
});

/**
 * FaCC that will inject the windowHeight / windowWidth into the chilren fn
 */
class WatchWindowSize extends React.Component<Props, State> {
  state = getWindowSize();

  componentDidMount() {
    window.addEventListener(RESIZE_EVENT, this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener(RESIZE_EVENT, this.onResize);
  }

  onResize = () => this.setState(getWindowSize());

  render() {
    return this.props.children({ ...this.state });
  }
}

export default WatchWindowSize;
